// ============================================================================
// cattle.batches.detail — migrated off the global read
// ============================================================================
// A persisted batch record needs its own keyed detail resource. Scheduled
// records additionally consume the shared forecast bundle for their projected
// roster; active and complete records leave that resource disabled.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'cattle.batches.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'cattle.batch.detail', owner: 'permanent'}),
    Object.freeze({id: 'cattle.forecast.bundle', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
